import '../app/DemandedJobs.scss'

function Header({title, subTitle = undefined}) {
    return (
        <div className="header-title">
            <div className="title">{title}</div>
            { subTitle && <div className="sub-title">{subTitle}</div> }
        </div>
    );
}

export default Header;